<template>
  <div class="mobile_estimate_list">
    <div class="el_sec_1" v-if="mode == 'VIEW'">
      <div class="profile_img">
        <div class="thumb_img">
          <div class="thumb_img_inner" @click.stop="goShopDetail(item.storeId)">
            <img v-if="storeInfo.storeProfile" :src="storeInfo.storeProfile" />
            <img
              v-else
              :src="setShopProfileImg(storeInfo.storeName, item.storeId)"
              alt=""
            />
            <img
              v-if="storeInfo.cert === 1"
              src="@/assets/front/images/new/icon_consent_s.png"
              alt=""
              class="mark"
            />
          </div>
        </div>
      </div>
      <div class="txt_area">
        <h1 class="store_name">
          {{ storeInfo.storeName }}
        </h1>
        <div class="store_info">
          <dl>
            <dt>휴대폰개통</dt>
            <dd>{{ storeInfo.mobileSaleCnt }}건</dd>
          </dl>
          <dl class="pnt" @click.stop="moreReview(item.storeId)">
            <dt>
              <img src="@/assets/front/images/v2/icons/ic_star_on.svg" />
            </dt>
            <dd>
              {{ Number(storeInfo.evaluationScore).toFixed(1) }}({{
                storeInfo.reviewCnt
              }}건)
            </dd>
          </dl>
        </div>
      </div>
      <div>
        <button
          class="btn_chat closed"
          v-if="
            isCounselClosed(
              item.estimateStore.counselDay,
              item.estimateStore.counselStart,
              item.estimateStore.counselEnd,
            )
          "
        >
          휴무
        </button>
        <button
          class="btn_chat"
          v-else-if="item.chat == 0"
          @click="mobileChat(selectIndex, item.chat)"
        >
          상담하기
        </button>
        <!--상담중일때 ing-->
        <button
          class="btn_chat ing"
          v-else-if="item.chat > 0"
          @click="enterChatRoom(item.storeId, item.chat)"
        >
          상담 중
        </button>
      </div>
    </div>

    <div class="el_sec_2" v-if="mode == 'DEAL'">
      <div class="device_img">
        <img :src="item.deviceImage" alt="" />
      </div>
      <div class="device_info">
        <div class="name">{{ item.modelName }}</div>
        <div class="plan">{{ item.joinPlanName }}</div>
      </div>
      <div class="device_detail">
        <button @click="goDeviceDetail(item.deviceId, item.id)">
          스팩보기 >
        </button>
      </div>
    </div>

    <div class="el_sec_3">
      <div class="sec_3_0" v-if="mode == 'VIEW'">
        {{ getCreateAt(item.estimatedAt) }}
      </div>
      <div class="sec_3_1">
        <div class="sec_3_1_1">
          <div class="sec_txt" v-if="item.payType == 'SUPPORT'">단말할인</div>
          <div class="sec_txt rd" v-else>요금할인</div>
          <div class="sec_txt" v-if="item.joinType == 'MNP'">번호이동</div>
          <div class="sec_txt" v-else-if="item.joinType == 'CHANGE'">
            기기변경
          </div>
          <div class="sec_txt" v-else-if="item.joinType == 'NEW'">신규가입</div>
          <div class="store_visit" v-if="item.openVisit == 1">
            <img
              :src="
                require('@/assets/front/images/v2/icons/ic_chat_btn_store.svg')
              "
            />
            <div class="txt">매장방문</div>
          </div>
          <div class="none_face" v-if="item.openOnline == 1">
            <img
              :src="require('@/assets/front/images/v2/icons/i_box_01.svg')"
            />
            <div class="txt">비대면</div>
          </div>
        </div>
        <div class="sec_3_1_2" v-if="mode == 'DEAL'">
          <button class="btn_chat" @click="enterChatRoomDeal(item.id)">
            상담하기
          </button>
        </div>
      </div>
      <div class="sec_3_2">
        <div class="sec_con">
          <div class="txt_1">통신사</div>
          <div class="txt_3 h40" v-if="mode == 'DEAL'">
            {{ item.telecomName }}
          </div>
          <div class="txt_3 h40" v-else-if="mode == 'VIEW'">
            {{ item.joinPlanInfo.telecomName }}
          </div>
        </div>
        <div class="sec_con">
          <div class="txt_1">가입 월 정액</div>
          <div class="txt_2">{{ toCurrency(item.joinPlanPrice) }}원</div>
          <div class="txt_3">{{ toCurrency(item.joinMonthlyRate) }}원</div>
        </div>
        <div class="sec_con">
          <div class="txt_1">단말기 구입가</div>
          <div class="txt_2">{{ toCurrency(item.factoryPrice) }}원</div>
          <div class="txt_3 rd">{{ toCurrency(item.principal) }}원</div>
        </div>
      </div>
    </div>

    <div class="sec_detail_view pnt" @click="goDetailView(item.id)">
      <div class="view_txt">상세 보기</div>
      <div class="view_img">
        <img
          :src="
            require(`@/assets/front/images/v2/arrows/ar_hash_next_blue.svg`)
          "
          alt=""
        />
      </div>
    </div>
  </div>
</template>
<script>
import * as util from '@common/lib/common/utils.js';
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';

export default {
  name: 'component-mobile-estimate-list',
  description: '휴대폰 견적서 리스트',
  components: {},
  props: {
    item: Object,
    storeInfo: Object,
    mode: {
      type: String,
      default: '',
    },
    selectIndex: {
      type: Number,
    },
  },
  filters: {
    comma(val) {
      return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    nl2br(val) {
      return String(val)
        .split('\n')
        .join('<br />');
    },
  },
  data() {
    return {};
  },
  created() {},
  computed: {},
  methods: {
    toCurrency(val) {
      return util.toCurrency(val);
    },
    getCreateAt(createAt) {
      return format(parseISO(createAt), 'yyyy.MM.dd HH:mm');
    },
    setShopProfileImg(shopName, shopId) {
      let path = util.setShopProfile(shopName, shopId, '140x140');

      return path;
    },
    moreReview(storeId) {
      this.$emit('moreReview', storeId);
    },
    goShopDetail(storeId) {
      this.$emit('goShopDetail', storeId);
    },
    goDetailView(id) {
      this.$emit('goDetailView', id);
    },
    enterChatRoom(id, chatCnt = '') {
      this.$emit('enterChatRoom', id, chatCnt);
    },
    enterChatRoomDeal(id) {
      this.$emit('enterChatRoom', id);
    },
    isCounselClosed(counselDay, counselStart, counselEnd) {
      let now = new Date();
      var week = new Array('7', '1', '2', '3', '4', '5', '6'); // 일, 월, 화, 수, 목, 금, 토

      let hours = now.getHours(); // 시
      let minutes = now.getMinutes(); // 분

      var startTime = counselStart.split(':');
      var endTime = counselEnd.split(':');

      // 있음, 영업함
      if (counselDay.indexOf(week[now.getDay()]) !== -1) {
        // 시간 확인
        if (parseInt(startTime[0]) <= hours && parseInt(endTime[0]) >= hours) {
          if (parseInt(endTime[1]) < minutes && parseInt(endTime[0]) == hours) {
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    mobileChat(index, chatCnt) {
      this.$emit('mobileChat', index, chatCnt);
    },
    goDeviceDetail(deviceId, id) {
      this.$emit('goDeviceDetail', deviceId, id);
    },
  },
};
</script>
